import CenturyExactTime from 'century-core/core-components/CenturyTime/CenturyExactTime';

export const TimeDuration = ({ timeSpentSeconds }: { timeSpentSeconds: number | undefined }) => {
  if (!timeSpentSeconds) {
    return null;
  }

  return <CenturyExactTime time={timeSpentSeconds} shortenUnits={true} excludeZeros={true} />;
};
